import { useTenant } from '@emerald-works-nova/auth'
import { Box, Typography, Divider } from '@mui/material'
import { useStyles } from './style'
import React from 'react'
import { useSelector } from 'react-redux'
import consts from '../../../consts'
import { useExternalApp, useFormFactor } from '../../../hooks'
import { contentSlice } from '../../../reducers'
import { ActionButton } from '../../action-buttons'
import ExpandLessTwoToneIcon from '@mui/icons-material/ExpandLessTwoTone'
import clsx from 'clsx'
import { css, keyframes } from '@emotion/react'
import { useEvent } from '@emerald-works/react-event-bus-client'

const getResouceAmountWording = (meteringLimit) => {
  const timeUnits = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
  return timeUnits[meteringLimit - 1]
}

const CallToActionMeteringUsage = () => {
  const tenant = useTenant()
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(true)
  const contentConsumed = useSelector(contentSlice.selectors.selectMeteringUsed)
  const meteringLimit = useSelector(contentSlice.selectors.selectMeteringLimit)
  const { getMtUrl } = useExternalApp()
  const { isMobile } = useFormFactor()
  const redirectToSignup = () => {
    window.location.href = getMtUrl('join')
  }
  const [meteringSignUpClick] = useEvent([{
    eventName: 'meteringSignUpClick',
    onSuccess: redirectToSignup,
    onError: redirectToSignup
  }])

  const handleMeteringSignupClick = () => {
    meteringSignUpClick.trigger({
      contentConsumed,
      meteringLimit
    })
  }

  const collapseContent = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(${isMobile ? 90 : 70}px);
  }
  `
  const expandContent = keyframes`
    from {
      transform: translateY(${isMobile ? 90 : 70}px);
    }
    to {
      transform: translateY(0);
    }
  `

  const isClubTenant = tenant.pk === consts.DEFAULT_CLUB_PK
  if (!isClubTenant) return null

  const remaining = meteringLimit - contentConsumed
  const resouceAmount = getResouceAmountWording(meteringLimit)
  const resourceWording = meteringLimit === 1 ? 'resource' : 'resources'
  const ctaPrimary = remaining === 0 ? `This is your ${resouceAmount} and last free resource` : `You have ${remaining} free ${resourceWording} from ${meteringLimit}.`

  const toggleNav = () => {
    setExpanded(!expanded)
  }
  const collapseDirection = expanded ? expandContent : collapseContent
  const arrowDirection = expanded ? classes.arrowUp : classes.arrowDown

  return (
    <Box
      onClick={toggleNav}
      sx={css`animation: ${collapseDirection} .5s ease`}
      className={classes.root}
    >
      <Box className={clsx(classes.header)}>
        <Typography className={classes.title}>{ctaPrimary}</Typography>
        <ExpandLessTwoToneIcon
          className={clsx(classes.arrowIcon, expanded && arrowDirection)}
        />
      </Box>
      <Box className={classes.content}>
        <>
          <Typography className={classes.ctaSecondary}>Enjoy unlimited access to Mindtools</Typography>
          <Divider orientation='vertical' className={classes.divider} />
        </>
        <ActionButton
          label='Join Now!'
          variant='secondary'
          className={classes.actionButton}
          onClick={handleMeteringSignupClick}
        />
      </Box>

    </Box>
  )
}

export default CallToActionMeteringUsage
